import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Logout } from '../assets/svg/logout.svg';
import { extractErrorDetail } from '../components/common';
import Button from '../components/mplat/Button/Button';
import { CheckBox } from '../components/mplat/CheckBox';
import Content from '../components/mplat/Content';
import Form from '../components/mplat/Form';
import Header1 from '../components/mplat/Header1';
import { useGetProfileQuery, useLazyGetAccountAgreementQuery, useLazyGetCurrentAccountQuery, useUpdateAccountAgreementMutation, useUpdateUserProfileAgreementMutation } from '../services/users_v1';
import NotFoundPage from './NotFoundPage';


function AgreementPage() {
    const { data: profile, error: profileError } = useGetProfileQuery(undefined);
    const [fetchAccountAgreement, { data: accountAgreement }] = useLazyGetAccountAgreementQuery();
    const [fetchUpdateProfileAgreement] = useUpdateUserProfileAgreementMutation();
    const [fetchUpdateAccountAgreement] = useUpdateAccountAgreementMutation();
    const [fetchUserAccount] = useLazyGetCurrentAccountQuery();
    const navigate = useNavigate();

    const [agree, setAgree] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (profile?.results.pd_agreement) {
            fetchAccountAgreement();
        }
    }, [profile]);

    let content = <NotFoundPage />;
    if (accountAgreement?.results.agr_offer) {
        content = <NotFoundPage />
    } else if (profile?.results.pd_agreement) {
        content = <Content>
            <div className="content__side-btn">
                <Link to="/logout" title={t('Log out')}>
                    <Logout />
                </Link>
            </div>
            <div className="user-settings">
                <Header1>
                    <Trans>Confirmation</Trans>
                </Header1>

                <Form>
                    <p>
                        <Trans i18nKey="ServiceAggreementMsg">
                            Please <a className="link-accent" href="https://media.msk-ix.ru/download/legal/ru/ServiceAgreement_Mediabaza.pdf" target="_blank" rel="noreferrer">link</a> .
                        </Trans>
                    </p>
                    <div className="form__item">
                        <CheckBox value={agree} label={t('Согласен')} onChange={(v) => setAgree(v)} />
                    </div>

                    <div className="user-settings__list-item" style={{ display: 'flex', cursor: 'pointer', alignItems: 'center', justifyContent: 'center' }} >
                        {error && <><br />{error}</>}
                        {profileError && <><br />{extractErrorDetail(profileError)}</>}
                    </div>
                    <div className="form__submit">
                        <Button disabled={!agree} onClick={() => {
                            fetchUpdateAccountAgreement().unwrap().then(() => {
                                fetchUserAccount();
                                window.location.pathname === '/agreement' && navigate('/');
                            }).catch((e) => {
                                setError(e.message);
                            });
                        }}>
                            <Trans>Confirm</Trans>
                        </Button>
                    </div>
                </Form>
            </div>
        </Content>
    } else {
        content = <Content>
            <div className="content__side-btn">
                <Link to="/logout" title={t('Log out')}>
                    <Logout />
                </Link>
            </div>
            <div className="user-settings">
                <Header1>
                    <Trans>Confirmation</Trans>
                </Header1>

                <Form>
                    <p>
                        <Trans i18nKey="PDConsent">
                            Please <a className="link-accent" href="https://media.msk-ix.ru/download/legal/ru/pd-consent_MSK-IX.pdf" target="_blank" rel="noreferrer">data</a>
                        </Trans>
                    </p>
                    <div className="form__item">
                        <CheckBox value={agree} label={t('Согласен')} onChange={(v) => setAgree(v)} />
                    </div>
                    <div className="user-settings__list-item" style={{ display: 'flex', cursor: 'pointer', alignItems: 'center', justifyContent: 'center' }} >
                        {error && <><br />{error}</>}
                        {profileError && <><br />{extractErrorDetail(profileError)}</>}
                    </div>
                    <div className="form__submit">
                        <Button disabled={!agree} onClick={() => {
                            fetchUpdateProfileAgreement().unwrap().then(() => {
                                navigate('/');
                            }).catch((e) => {
                                setError(e.message);
                            });
                        }}>
                            <Trans>Confirm</Trans>
                        </Button>
                    </div>
                </Form>
            </div>
        </Content>
    }

    return content;
}

export default AgreementPage;
